import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { buttonCss } from './button';

export const ButtonWhite = ({ children, ...props }) => <ButtonView {...props}>{children}</ButtonView>;

const ButtonView = styled.button`
  ${buttonCss};
  background-color: ${Colors.white};
  color: ${Colors.coal};
  border: 1px solid ${Colors.solitude};

  &:hover {
    background-color: ${Colors.electric_blue};
    color: ${Colors.white};
  }
`;
